<template lang="pug">
  component(
    :is="layout"
    :workspace="workspace"
  )
    //- Forçando o reload do componente a cada mudança de rota :key="$route.params.eref"
    router-view
</template>

<style lang="scss">
@import 'styles/styles.scss';
@import 'styles/colors.scss';
</style>

<script lang="js">
import { ENTITY } from '@/store/mutation-types'
import { canonicalizeWorkspaceLink } from '@/helpers/canonicalization'
import { mapState } from 'vuex'

import AppLoading from '@/views/pages/AppLoading'
import LayoutBlank from '@/layouts/Blank.vue'
import LayoutContent from '@/layouts/Content.vue'

export default {
  components: {
    AppLoading,
    LayoutBlank,
    LayoutContent,
  },

  data: () => ({
  }),

  beforeMount () {
    this.restoreWorkspace()
  },

  watch: {
    $route (to, from) {
      this.restoreWorkspace()
    },
  },

  computed: {
    ...mapState({
      workspace (state) {
        return state[ENTITY][this.workspaceLink.path]
      },
    }),

    workspaceLink () {
      const { site, eref } = this.$route.params
      return canonicalizeWorkspaceLink(this, { site, eref })
    },

    layout () {
      const route = this.$route
      if (route.name === null) return null
      if (route.meta.layout === 'blank') return 'layout-blank'

      return 'layout-content'
    },
  },

  methods: {
    async restoreWorkspace () {
      // Sincronizando a área de trabalho...
      await this.$resolve(this.workspaceLink)
    },
  },
}
</script>